import { render, staticRenderFns } from "./dictionaries.vue?vue&type=template&id=0a0366bc&scoped=true&"
import script from "./dictionaries.vue?vue&type=script&lang=js&"
export * from "./dictionaries.vue?vue&type=script&lang=js&"
import style0 from "./dictionaries.vue?vue&type=style&index=0&id=0a0366bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0366bc",
  null
  
)

export default component.exports